import { render } from "./TabComentarios.vue?vue&type=template&id=037f7fea&scoped=true"
import script from "./TabComentarios.vue?vue&type=script&lang=js"
export * from "./TabComentarios.vue?vue&type=script&lang=js"

import "./TabComentarios.vue?vue&type=style&index=0&id=037f7fea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037f7fea"]])

export default __exports__